let globalPreferredLanguage: string | undefined;

export function setPreferredLanguage(lang = 'en-US') {
  globalPreferredLanguage = lang;
}

export function getPreferredLanguage() {
  return globalPreferredLanguage;
}
